import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { isEmpty } from "lodash";
import useStyles from "../../../../style/js-style/containers/administration/rules/RuleFormsStyle";
import { getCriterionModel, getRuleActionModel } from "services/common/RulesUtils";

const getFormDefaultValues = (rule) => {
  return {
    ruleId: rule?.id || "",
    name: rule?.name || "",
    enabled: rule?.enabled || false,
    accountId: rule?.accountId || "",
    type: rule?.type || "",
    criteria: rule?.criteria?.map((item) => {
      return {
        id: item.id,
        targetField: item.targetField,
        operator: item.operator,
        values: item.values || [{
          id: "",
          value: "",
        }],
      }
    }) || [
        getCriterionModel()
      ],

    actions: rule?.actions?.map((item) => {
      return {
        id: item?.id,
        type: item?.type,
        parameters: item?.parameters,
        ruleId: item?.ruleId,
      }
    }) || [
        getRuleActionModel(),
      ]
  };
};

const RuleForm = ({ rule, formId, submitHandler, children }) => {
  const { classes } = useStyles();

  const formMethods = useForm({
    mode: "onChange",
    delayError: 500,
    defaultValues: getFormDefaultValues(rule),
  });

  const {
    formState: { errors },
  } = formMethods;

  const submitForm = (data) => {
    if (isEmpty(errors)) {
      submitHandler(data);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form
        id={formId}
        onSubmit={formMethods.handleSubmit(submitForm)}
        className={classes.formContainer}
      >
        {children}
      </form>
    </FormProvider>
  );
}

export default RuleForm;